package kz.dentalcrm.app.screens.employees.add.mvi

import kz.dentalcrm.app.core.base.ViewSideEffect

sealed interface AddEmployeeSideEffect : ViewSideEffect {
    data object SaveSuccess : AddEmployeeSideEffect
    data class ShowError(val message: String) : AddEmployeeSideEffect
}
